import { render, staticRenderFns } from "./PageTemplate.vue?vue&type=template&id=785100ca&scoped=true"
import script from "./PageTemplate.vue?vue&type=script&lang=js"
export * from "./PageTemplate.vue?vue&type=script&lang=js"
import style0 from "./PageTemplate.vue?vue&type=style&index=0&id=785100ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785100ca",
  null
  
)

export default component.exports